import React from "react";

interface NewsletterTemplateProps {
  userName?: string;
  featuredSpaces?: Array<{
    name: string;
    image: string;
    price: string;
    location: string;
    type: string;
  }>;
  promotionTitle?: string;
  promotionDiscount?: string;
}

const NewsletterTemplate: React.FC<NewsletterTemplateProps> = ({
  userName = "Cher membre EventToBee",
  featuredSpaces = [
    {
      name: "Loft industriel Bastille",
      image: "https://via.placeholder.com/300x200/667eea/ffffff?text=Loft",
      price: "120€/jour",
      location: "Paris 11e",
      type: "Loft",
    },
    {
      name: "Jardin secret Montmartre",
      image: "https://via.placeholder.com/300x200/10b981/ffffff?text=Jardin",
      price: "200€/jour",
      location: "Paris 18e",
      type: "Jardin",
    },
    {
      name: "Salle moderne La Défense",
      image: "https://via.placeholder.com/300x200/f59e0b/ffffff?text=Salle",
      price: "300€/jour",
      location: "La Défense",
      type: "Salle",
    },
  ],
  promotionTitle = "🎉 WEEK-END PROLONGÉ",
  promotionDiscount = "20%",
}) => {
  const templateHTML = `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Newsletter EventToBee - Nouveautés & Promotions 🐝</title>
    <style>
        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            margin: 0;
            padding: 0;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: #333;
        }
        .container {
            max-width: 700px;
            margin: 20px auto;
            background: white;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 20px 60px rgba(0,0,0,0.1);
        }
        .header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            padding: 30px;
            text-align: center;
            color: white;
            position: relative;
        }
        .header::before {
            content: '📰';
            position: absolute;
            top: 15px;
            right: 25px;
            font-size: 28px;
            opacity: 0.7;
        }
        .logo {
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 8px;
        }
        .newsletter-title {
            font-size: 20px;
            margin-bottom: 5px;
        }
        .newsletter-date {
            font-size: 14px;
            opacity: 0.8;
        }
        .content {
            padding: 30px;
        }
        .promotion-banner {
            background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
            color: #92400e;
            padding: 25px;
            border-radius: 15px;
            text-align: center;
            margin: 25px 0;
            position: relative;
            overflow: hidden;
        }
        .promotion-banner::before {
            content: '🎁';
            position: absolute;
            top: 10px;
            left: 20px;
            font-size: 24px;
            opacity: 0.7;
        }
        .promotion-title {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 10px;
        }
        .promotion-discount {
            font-size: 36px;
            font-weight: bold;
            margin: 10px 0;
        }
        .promotion-desc {
            font-size: 16px;
            margin-bottom: 15px;
        }
        .section-title {
            font-size: 24px;
            font-weight: bold;
            color: #1e293b;
            margin: 30px 0 20px 0;
            padding-bottom: 10px;
            border-bottom: 3px solid #667eea;
            position: relative;
        }
        .section-title::before {
            content: '🏠';
            margin-right: 10px;
        }
        .spaces-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 20px;
            margin: 25px 0;
        }
        .space-card {
            background: white;
            border-radius: 15px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0,0,0,0.1);
            transition: transform 0.3s ease;
            border: 2px solid #f1f5f9;
        }
        .space-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 20px 40px rgba(0,0,0,0.15);
        }
        .space-image {
            width: 100%;
            height: 150px;
            object-fit: cover;
        }
        .space-info {
            padding: 15px;
        }
        .space-name {
            font-weight: bold;
            color: #1e293b;
            margin-bottom: 5px;
            font-size: 16px;
        }
        .space-location {
            color: #64748b;
            font-size: 14px;
            margin-bottom: 10px;
        }
        .space-price {
            color: #10b981;
            font-weight: bold;
            font-size: 16px;
        }
        .space-type {
            background: #667eea;
            color: white;
            padding: 4px 8px;
            border-radius: 20px;
            font-size: 12px;
            display: inline-block;
            margin-top: 8px;
        }
        .tips-section {
            background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
            padding: 25px;
            border-radius: 15px;
            margin: 25px 0;
            border-left: 5px solid #10b981;
        }
        .tips-title {
            font-size: 18px;
            font-weight: bold;
            color: #065f46;
            margin-bottom: 15px;
        }
        .tips-list {
            list-style: none;
            padding: 0;
            margin: 0;
        }
        .tips-list li {
            padding: 8px 0;
            color: #047857;
            font-size: 14px;
        }
        .tips-list li::before {
            content: '💡 ';
            margin-right: 5px;
        }
        .stats-section {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
            gap: 15px;
            margin: 25px 0;
        }
        .stat-card {
            background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
            padding: 20px;
            border-radius: 15px;
            text-align: center;
            border: 2px solid #e2e8f0;
        }
        .stat-number {
            font-size: 28px;
            font-weight: bold;
            color: #667eea;
            margin-bottom: 5px;
        }
        .stat-label {
            font-size: 12px;
            color: #64748b;
            text-transform: uppercase;
            font-weight: bold;
        }
        .cta-section {
            text-align: center;
            margin: 30px 0;
        }
        .cta-button {
            display: inline-block;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 15px 30px;
            text-decoration: none;
            border-radius: 50px;
            font-weight: bold;
            margin: 10px;
            transition: transform 0.3s ease;
        }
        .cta-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
        }
        .footer {
            background: #f8f9fa;
            padding: 25px;
            text-align: center;
            font-size: 14px;
            color: #666;
            border-top: 1px solid #eee;
        }
        .social-links {
            margin: 20px 0;
        }
        .social-links a {
            display: inline-block;
            margin: 0 15px;
            color: #667eea;
            text-decoration: none;
            font-size: 16px;
        }
        @media (max-width: 600px) {
            .container { margin: 10px; }
            .spaces-grid { grid-template-columns: 1fr; }
            .stats-section { grid-template-columns: repeat(2, 1fr); }
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <div class="logo">🐝 EventToBee</div>
            <div class="newsletter-title">Newsletter Hebdomadaire</div>
            <div class="newsletter-date">${new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" })}</div>
        </div>

        <div class="content">
            <p style="font-size: 16px; margin-bottom: 20px;">
                Bonjour <strong>${userName}</strong> ! 👋
            </p>

            <p style="color: #64748b; margin-bottom: 25px;">
                Découvrez cette semaine nos nouveaux espaces, promotions exclusives et conseils d'experts pour réussir vos événements.
            </p>

            <div class="promotion-banner">
                <div class="promotion-title">${promotionTitle}</div>
                <div class="promotion-discount">-${promotionDiscount}</div>
                <div class="promotion-desc">Sur tous les espaces premium</div>
                <a href="#" class="cta-button" style="background: #92400e; margin-top: 10px;">
                    🏃‍♂️ J'en profite maintenant
                </a>
            </div>

            <div class="stats-section">
                <div class="stat-card">
                    <div class="stat-number">847</div>
                    <div class="stat-label">Espaces actifs</div>
                </div>
                <div class="stat-card">
                    <div class="stat-number">2.3k</div>
                    <div class="stat-label">Événements ce mois</div>
                </div>
                <div class="stat-card">
                    <div class="stat-number">98%</div>
                    <div class="stat-label">Satisfaction client</div>
                </div>
                <div class="stat-card">
                    <div class="stat-number">24</div>
                    <div class="stat-label">Nouveaux espaces</div>
                </div>
            </div>

            <h2 class="section-title">Espaces en vedette cette semaine</h2>

            <div class="spaces-grid">
                ${featuredSpaces
                  .map(
                    (space) => `
                    <div class="space-card">
                        <img src="${space.image}" alt="${space.name}" class="space-image">
                        <div class="space-info">
                            <div class="space-name">${space.name}</div>
                            <div class="space-location">📍 ${space.location}</div>
                            <div class="space-price">${space.price}</div>
                            <div class="space-type">${space.type}</div>
                        </div>
                    </div>
                `
                  )
                  .join("")}
            </div>

            <div class="tips-section">
                <div class="tips-title">💡 Conseils de la semaine</div>
                <ul class="tips-list">
                    <li><strong>Réservez en avance :</strong> Les meilleurs espaces partent vite, surtout pour les week-ends</li>
                    <li><strong>Visitez avant :</strong> Demandez une visite virtuelle ou physique pour éviter les surprises</li>
                    <li><strong>Négociez :</strong> Pour les longues durées, n'hésitez pas à demander un tarif préférentiel</li>
                    <li><strong>Lisez les avis :</strong> Les commentaires clients sont précieux pour faire votre choix</li>
                </ul>
            </div>

            <div class="cta-section">
                <a href="#" class="cta-button">🔍 Découvrir tous les espaces</a>
                <a href="#" class="cta-button">📱 Télécharger l'app</a>
            </div>

            <p style="text-align: center; color: #64748b; margin-top: 30px; padding: 20px; background: #f8fafc; border-radius: 10px;">
                <strong>🎯 Le saviez-vous ?</strong><br>
                Les réservations effectuées le mardi sont 23% moins chères en moyenne !
                C'est le moment idéal pour planifier vos événements futurs.
            </p>
        </div>

        <div class="footer">
            <div class="social-links">
                <a href="#">📘 Facebook</a>
                <a href="#">📸 Instagram</a>
                <a href="#">🐦 Twitter</a>
                <a href="#">💼 LinkedIn</a>
                <a href="#">📱 TikTok</a>
            </div>

            <p>
                <strong>EventToBee</strong> - La ruche des espaces événementiels 🐝<br>
                Paris & Île-de-France | <a href="mailto:newsletter@eventtobee.com" style="color: #667eea;">newsletter@eventtobee.com</a>
            </p>

            <p style="font-size: 12px; color: #999; margin-top: 20px;">
                Vous recevez cette newsletter car vous êtes abonné à EventToBee.<br>
                <a href="#" style="color: #667eea;">Se désabonner</a> |
                <a href="#" style="color: #667eea;">Gérer mes préférences</a> |
                <a href="#" style="color: #667eea;">Transférer à un ami</a>
            </p>
        </div>
    </div>
</body>
</html>`;

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">📧 Template: Newsletter Hebdomadaire</h3>
      <div className="mb-4">
        <button
          className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600"
          onClick={() => navigator.clipboard.writeText(templateHTML)}
        >
          📋 Copier le code HTML
        </button>
      </div>
      <div
        className="border rounded-lg p-4 bg-gray-50 max-h-96 overflow-y-auto"
        dangerouslySetInnerHTML={{ __html: templateHTML }}
      />
    </div>
  );
};

export default NewsletterTemplate;
